import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRoute, ActivatedRouteSnapshot, Router } from '@angular/router';
import { CommonService } from '@app/shared/common/common.service';
import { environment } from '@env/environment';
import { Observable } from 'rxjs';
import { AppState } from '@app/app.service';
import { HttpClient } from '@angular/common/http';
import { JoyrideService } from 'ngx-joyride';
import { EmitService } from '@app/ts/services/emit.service';
@Injectable()
export class AuthGuard implements CanActivate {
  routerPermission: any;
  constructor(private router: Router,private appService : AppState,private commonService:CommonService,private http: HttpClient, private joyrideService: JoyrideService,
    private emitService: EmitService ) {
  }
  canActivate(route: ActivatedRouteSnapshot): Observable<boolean>|Promise<boolean>|boolean {
    let roles = route.data.rights as string;
    let permissionCookie = this.commonService.getCookie(environment.permissions);
    this.routerPermission = this.commonService.decrypt(decodeURIComponent(permissionCookie));
    // if( !this.routerPermission.includes(roles)){
    //   window.location.href = environment.LOGOUT_URL[localStorage.getEncryptedItem('domain')]+encodeURIComponent(this.commonService.encrypt(window.location.href))
    // }
    let cookieExist = this.commonService.getCookie(environment.checkCookie);
    if (cookieExist == "") {
      if( !localStorage.getEncryptedItem('ACCOUNTS_URL')){
        const host = window.location.host
        const parts = host.split(".");
        parts.shift();
        const domain = parts.join(".");
        let formData = new FormData();
        formData.append('domain', localStorage.getEncryptedItem('domain'));
        let object = this.commonService.createObject(formData);
        let token = this.commonService.createToken(object);
        let encryptedToken = this.commonService.encrypt(token);
        let encrData = new FormData();
        encrData.append('encrToken', encryptedToken);
        let API_END_POINT_ACCOUNTS = 'https://fjy29.api.' + domain + '/api/v1/';
        // let API_END_POINT_ACCOUNTS = 'http://testaccounts.api.' + domain + ':8080/api/v1/';
        this.http.post(API_END_POINT_ACCOUNTS + 'auth/getWhiteLabelConfig', encrData).subscribe( dataFromApi => {
          if (dataFromApi["status"]) {
            let config = dataFromApi['data']['configdata'];
            localStorage.setEncryptedItem('API_END_POINT_ACCOUNTS', config['accounts_api_url']);
            localStorage.setEncryptedItem('API_END_POINT_ADMIN', config['admin_api_url']);
            localStorage.setEncryptedItem('API_END_POINT_GATE2B', config['gate2b_api_url']);
            localStorage.setEncryptedItem('ACCOUNTS_URL', config['accounts_url']);
            localStorage.setEncryptedItem('ADMIN_URL', config['admin_url']);
            localStorage.setEncryptedItem('GATE2B_URL', config['gate2b_url']);
            window.location.href = localStorage.getEncryptedItem('ACCOUNTS_URL')+'auth/logout/'+encodeURIComponent(this.commonService.encrypt(window.location.href))
          }
        });
      }else{
        window.location.href = localStorage.getEncryptedItem('ACCOUNTS_URL')+'auth/logout/'+encodeURIComponent(this.commonService.encrypt(window.location.href))
      }
    }
    else{
      let expiredCookie = this.commonService.decrypt(decodeURIComponent(cookieExist))
      if (this.tokenExpired(expiredCookie)) {
        // token expired
        this.appService.createAccessToken().subscribe(data=>{ });
      } 
      const userDataRow = localStorage.getEncryptedItem('userData');
      const userData = userDataRow ? JSON.parse(userDataRow) : [];
      const isSubscriptionFound = userData.length > 0 ? userData[0].isSubscriptionFound : false;  
      if( !localStorage.getEncryptedItem('userData') || !isSubscriptionFound){
        let formData = new FormData();
        formData.append('code','EDI');
        formData.append('accId',localStorage.getEncryptedItem('accId'));
        formData.append('partyID',localStorage.getEncryptedItem('partyID'));
        let objectUser = this.commonService.createObject(formData);
        let tokenUser = this.commonService.createToken(objectUser);
        let encryptedTokenUser = this.commonService.encrypt(tokenUser);
        let encrDataUser = new FormData();
        encrDataUser.append("encrToken", encryptedTokenUser);
        let tempPath = window.location.hash.replace('#/','') == '' ? 'userDashboard' : window.location.hash.replace('#/','');
        this.http.post(localStorage.getEncryptedItem('API_END_POINT_ACCOUNTS')+'users/user-profile',encrDataUser).subscribe(dataFromApi => {
          let user = dataFromApi['data'];
          let permissions = String(user[0].permissions.Allow);
          this.commonService.setCookie(environment.permissions,this.commonService.encrypt(permissions),10000,'','/');
          localStorage.setEncryptedItem('userData', JSON.stringify(user));
          localStorage.setEncryptedItem('accId',user[0].accId);
          localStorage.setEncryptedItem('isCompanyConfirmed',user[0].isConfirmedParty.toString());
          localStorage.setEncryptedItem('isAddressEmpty',user[0].isAddressEmpty.toString());
          localStorage.setEncryptedItem('hasPermission',user[0].hasPermission.toString());
          localStorage.setEncryptedItem('hideTutorial',user[0].hidetutorial.toString());
          let arr=[];
          user[0].interConnect.forEach(element => {
            arr.push(element.interconnectid)
          });
          localStorage.setEncryptedItem('interConnectCompany',JSON.stringify(arr));
          let permissionCookie = this.commonService.getCookie(environment.permissions);
          this.routerPermission = this.commonService.decrypt(decodeURIComponent(permissionCookie));
          let userName = user[0].username;
          let companyList = user[0].companyDetails;
          let company = companyList.filter(item=>item.partyid == localStorage.getEncryptedItem('partyID'));
          let companyName = company[0]['companyname'];
          let companyMode = company[0]['companymode']
          let userInfo = {};
          userInfo["userName"] = userName;
          userInfo["companyName"] = companyName;
          userInfo["companyMode"] = companyMode;
          this.commonService.setCookie(this.commonService.encrypt(environment.userInfo),this.commonService.encrypt(JSON.stringify(userInfo)),10000,'','/');
          setTimeout(() => {
            let language = user[0].language ? user[0].language : 'de';
            this.emitService.emitLoginLanguageChange(language);
          },100)
          if(!user[0].isSubscriptionFound) {
            window.location.href = localStorage.getEncryptedItem('BILLING_URL')+'user-plans';
            return;
          }
          if( !this.routerPermission.includes(roles)){
            window.location.href = localStorage.getEncryptedItem('ACCOUNTS_URL')+'profile';
            return;
          }
          window.location.href = localStorage.getEncryptedItem('GATE2B_URL') + tempPath ;
        });
      } 
      else{

        if( !this.routerPermission.includes(roles)){      
            window.location.href = localStorage.getEncryptedItem('ACCOUNTS_URL')+'profile';
            return;
          }
        return true;
      }
  }
  }
  
  private tokenExpired(token) {
    let cookieExpiredTime = JSON.parse(token)
    return new Date(cookieExpiredTime[environment.tokenExpireTime]).getTime() < new Date().getTime();
  }
  
}
